import { Component, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-login-form',
	imports: [TranslateModule],
	templateUrl: './login-failed.component.html',
	styleUrl: './login-failed.component.scss',
})
export class LoginFailedComponent {
	private router = inject(Router);
	private route = inject(ActivatedRoute);

	username = '';
	password = '';

	login() {
		console.log(this.username);
		console.log(this.password);
		localStorage['token'] =
			'Basic ' + btoa(this.username + ':' + this.password);
		this.router.navigateByUrl(
			this.route.snapshot.queryParamMap.get('redirect') ?? '/',
		);
	}
}
